import React from 'react';
import { ConfirmProvider } from 'material-ui-confirm';
import { SnackbarProvider } from 'notistack';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';

import { messages } from './messages';
import { InternalError } from './pages/internal-error';
import { Router } from './routes';
import { SupabaseProvider } from './supabase';
import { ThemeProvider } from './theme';
import { ErrorBoundary } from './utils/error-boundary';
import { LocaleProvider } from './utils/locale-provider';
import { TrpcProvider } from './utils/trpc';
import { UserProvider } from './utils/user-provider';

export const Main = () => {
	return (
		<ThemeProvider>
			{/* Fallback locale for the error page rendered above the Supabase session. */}
			<IntlProvider locale="cs" defaultLocale="cs" messages={messages.cs}>
				<SnackbarProvider>
					{/* v4 flipped confirm() from reject-on-cancel to resolving { confirmed }.
					    All 15 call sites use the v3 shape, several guarding destructive
					    actions, so keep v3 semantics rather than rewriting them. */}
					<ConfirmProvider useLegacyReturn>
						<ErrorBoundary errorPage={<InternalError />}>
							<TrpcProvider>
								<SupabaseProvider>
									<LocaleProvider>
										<UserProvider>
											<BrowserRouter>
												<NuqsAdapter>
													<Router />
												</NuqsAdapter>
											</BrowserRouter>
										</UserProvider>
									</LocaleProvider>
								</SupabaseProvider>
							</TrpcProvider>
						</ErrorBoundary>
					</ConfirmProvider>
				</SnackbarProvider>
			</IntlProvider>
		</ThemeProvider>
	);
};
